/* eslint-disable @typescript-eslint/no-explicit-any */
import type {
  ComponentPropsWithRef,
  ComponentType,
  ReactElement,
} from 'react';

import styled, { useTheme } from 'styled-components';

export const StyledClearButton = styled.div({
  display: 'inline-flex',
  width: 16,
  height: 16,
  margin: 0,
  padding: 0,
  outline: 'none',
  backgroundColor: 'transparent',
  border: 'none',
  verticalAlign: 'middle',
});

export type ClearButtonProps<
ClearButtonComponent extends keyof JSX.IntrinsicElements | ComponentType<any>,
> = {
  as?: ClearButtonComponent;
} & Omit<ComponentPropsWithRef<ClearButtonComponent>, 'as'>;

export function ClearButton<
ClearButtonComponent extends keyof JSX.IntrinsicElements | ComponentType<any> = 'span',
>({
  as: ButtonComponent = 'span' as ClearButtonComponent,
  ...rest
}: ClearButtonProps<ClearButtonComponent>): ReactElement {
  const { input } = useTheme();

  return (
    <StyledClearButton
      {...rest}
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      as={ButtonComponent as any}
    >
      {input.CLEAR_ICON}
    </StyledClearButton>
  );
}
